<div [formGroup]="userFieldsForm" class="flex flex-col gap-10">
    
    @for (group of fieldGroups(); track group.name) {
        <app-group-renderer-user-fields
          [group]="group"
          [form]="userFieldsForm"
          [externalOptionsMap]="externalOptionsMap()">
        </app-group-renderer-user-fields>
      }
</div>